import React, { FC } from 'react';

import styles from './MatchObjectCell.module.scss';

type MatchObjectCellProps = {
  matchName? : string;
};

export const MatchObjectCell: FC<MatchObjectCellProps> = ({ matchName }) => {
  return (
    <li className={styles.matchName}
        data-test="match-name">
      {matchName || '––'}
    </li>
  );
};
